import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { useState, useMemo } from "react";
import useBangKeoMatches from "@/hooks/useBangKeoMatches";
import TiLeMatch from "@/components/TiLeMatch";
import LoadingInner from "@/components/Loading";
import NoData from "@/components/NoData";
import MatchLeagues from "@/components/MatchLeagues";
import KbvDateRange from "@/components/DateRange";
import { BANG_KEO_PAGE_LIMIT } from "@/contants";
import Carousel from "@/components/Carousel";
import HotLeaguesPanel from "@/components/HotLeaguesPanel";
import { useLeague } from "@/hooks/useLeague";


dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";


const KbvBangKeo = ({ type = "all" }) => {
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [selectedDateValue, setSelectedDateValue] = useState(today);

  const dateString =
    selectedDateValue === "live" ? today : selectedDateValue;
  const status =
    type === "ketqua" ? "end" : selectedDateValue === "live" ? "live" : "";

  const queryObject = useMemo(
    () => ({
      include: "homeTeam,awayTeam,odd,countOtherOdds,stats,events,insight",
      filterInclude: `date:${dateString}`,
      filterOdds: -1,
      cache: false,
      status,
      page: 1,
      limit: BANG_KEO_PAGE_LIMIT,
    }),
    [dateString, status]
  );

  const {
    leaguesWithMatches,
    loading,
    hasMore,
    loadMoreRef,
    isLoadingMoreRef,
    matches,
  } = useBangKeoMatches(queryObject);

  const { selectedLeague } = useLeague();
  const filteredLeagues = useMemo(() => {
    if (!selectedLeague || selectedLeague.id === 0) {
      return leaguesWithMatches;
    }
    return leaguesWithMatches.filter(
      ({ league }) => String(league?.id) === String(selectedLeague.id)
    );
  }, [leaguesWithMatches, selectedLeague]);


  return (
    <div className="flex flex-col gap-2">
      <div className="md:grid md:grid-cols-[224px_minmax(0,1fr)] md:items-start">
        <div className="hidden md:block md:col-span-1">
          <HotLeaguesPanel />
        </div>
        <div className="md:col-span-1">
          <KbvDateRange
            value={selectedDateValue}
            onChange={setSelectedDateValue}
          />
          
          <Carousel matches={matches} />

          {loading && <LoadingInner />}
          {
            !loading && (
              <>
                <div className="space-y-2 rounded-lg p-2">
                  {
                    filteredLeagues.length === 0 ? (
                      <NoData message="Không có trận đấu nào" />
                        
                    ) : (
                      filteredLeagues.map(({ league, matches }) => (
                        <MatchLeagues key={league.id} league={league} matches={matches} render={(match) => <TiLeMatch key={match.id} match={match} /> } />
                      ))
                    )

                  }
                </div>
                {/* {hasMore && (
                  <div ref={loadMoreRef} className="py-4 text-center">
                    {isLoadingMoreRef && <LoadingInner />}
                  </div>
                )} */}
              </>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default KbvBangKeo;